import { sentry } from '@chilipiper/config'
import {
  init as initSentry,
  BrowserOptions,
  setTag,
  reactRouterV6BrowserTracingIntegration,
  browserTracingIntegration,
  replayIntegration,
  breadcrumbsIntegration,
  functionToStringIntegration,
  browserApiErrorsIntegration,
  browserSessionIntegration,
} from '@sentry/react'

const init = (
  dsn: string,
  {
    integrations,
    ...options
  }: Omit<BrowserOptions, 'integrations'> & {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    integrations?: Exclude<BrowserOptions['integrations'], Function>
  } = {},
  routingIntegration?: ReturnType<typeof reactRouterV6BrowserTracingIntegration>
) => {
  initSentry({
    dsn,
    debug: process.env.NODE_ENV === 'development',
    release: sentry.release,
    integrations: [
      routingIntegration ?? browserTracingIntegration(),
      replayIntegration(),
      browserApiErrorsIntegration(),
      functionToStringIntegration(),
      breadcrumbsIntegration({
        dom: {
          serializeAttribute: ['data-test-id', 'class'],
        },
      }),
      browserSessionIntegration(),
      ...(integrations ?? []),
    ],
    tracesSampleRate: 1,
    environment: sentry.env,
    sampleRate: 1,
    denyUrls: [
      // Rollout server error
      /rollout\.io/,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    ignoreErrors: [
      'TypeError: Cancelled', //https://forum.sentry.io/t/typeerror-cancelled-how-do-i-find-out-which-request-it-was/10786
      'TypeError: Failed to fetch',
      'Non-Error exception captured with keys',
      'UnhandledRejection: Non-Error promise rejection captured', //https://docs.google.com/document/d/172Sc618sdMUr3Nxa1iEr6z8vqQatvy2iA06N3m-v9J0
      'TypeError: NetworkError when attempting to fetch resource.',
      'ResizeObserver loop limit exceeded', // https://stackoverflow.com/a/50387233/2652124
      ...(options.ignoreErrors || []),
    ],
    ...options,
  })

  setTag('environment', sentry.env)
}

enum SeverityLevels {
  Debug = 'debug',
  Error = 'error',
  Fatal = 'fatal',
  Info = 'info',
  Log = 'log',
  Warning = 'warning',
}

export { init, SeverityLevels }
